/*
  Lokaler Ersatz für den nicht mehr erreichbaren Fork
  https://github.com/forty-four/react-exif-orientation-img
  (basiert auf react-exif-orientation-img@0.1.5, MIT).

  Unterschied zum Original (wie im Fork, siehe monkeypatch_backup.js):
  Die EXIF-Orientierung wird zusätzlich als CSS-Klasse angehängt (z.B. "o1", "o6", "o8"),
  darauf bauen die Styles in material-dashboard-*.css (.picture-src.o6 / .o8 / .o1) auf.
*/
import React, { Component } from 'react'
import EXIF from 'exif-js'
import exif2css from 'exif2css'

const snakeToCamelCaseKeys = (obj) =>
  Object.keys(obj).reduce((acc, key) => {
    acc[key.replace(/(-\w)/g, (m) => m[1].toUpperCase())] = obj[key]
    return acc
  }, {})

export default class ExifOrientationImg extends Component {
  state = {
    orientation: null,
  }

  onImageLoaded = (event, ...otherArgs) => {
    const imageElement = event.target
    const { onLoad } = this.props

    // Fix für exif-js: https://github.com/exif-js/exif-js/issues/95
    const windowImage = window.Image
    window.Image = null

    const started = EXIF.getData(imageElement, () => {
      this.setState({ orientation: EXIF.getTag(imageElement, 'Orientation') })
      onLoad && onLoad(event, ...otherArgs)
    })
    if (!started) {
      onLoad && onLoad(event, ...otherArgs)
    }

    window.Image = windowImage
  }

  render() {
    const { src, alt, className, style = {}, onLoad, ...imgProps } = this.props
    const { orientation } = this.state

    return (
      <img
        {...imgProps}
        onLoad={this.onImageLoaded}
        src={src}
        alt={alt}
        className={[className, 'o' + orientation].filter(Boolean).join(' ')}
        style={{ ...(orientation ? snakeToCamelCaseKeys(exif2css(orientation)) : {}), ...style }}
      />
    )
  }
}
